// extracted by mini-css-extract-plugin
module.exports = {"main":"Terms_main__Ae0F6","container":"Terms_container__2xyE3","head":"Terms_head__wTj2B","header":"Terms_header__1k9Lh","section":"Terms_section__20Vel"};